import * as React from 'react';

import { Button } from '@ao-internal/components-react';
import * as digitalData from '@ao-internal/digital-data';

import { TaggingEventNames } from '../../globals';
import useChat from '../../hooks/useChat';
import {
	ChatMessageTypes,
	ChatMessageTypesClassMap,
	InputTypes,
} from '../../store';

export interface SuggestedPhrasesMessageContent {
	displayText: string;
	replyText: string;
}

interface SuggestedPhrasesMessageProps {
	groupIntent?: string;
	phrases: SuggestedPhrasesMessageContent[];
	isReadOnly?: boolean;
}

export const dataTestId = `${
	ChatMessageTypesClassMap[ChatMessageTypes.SuggestedPhrases]
}-message`;

export const SuggestedPhrasesMessage: React.FC<SuggestedPhrasesMessageProps> =
	({ groupIntent, phrases, isReadOnly }) => {
		const { sendMessage } = useChat();

		const handleClick = (evt: React.MouseEvent, index: number) => {
			const targetButton = phrases[index];

			digitalData.sendBeacon(TaggingEventNames.interaction, {
				type: 'click',
				element: 'suggested-phrases-message',
				value: targetButton.replyText,
			});

			sendMessage(targetButton.replyText, {
				groupIntent,
				inputType: InputTypes.Interaction,
			});
		};

		return (
			<div
				ref={(node) => node && isReadOnly && node.setAttribute('inert', '')}
				data-testid={dataTestId}
				className="mx-2"
				data-tag-area="suggested phrases message"
			>
				<div className="flex flex-col items-end -mx-1">
					{phrases.map(
						(phrase: SuggestedPhrasesMessageContent, index: number) => {
							const position = index + 1;
							return (
								<Button
									// eslint-disable-next-line react/no-array-index-key
									key={`button-${index}`}
									data-tag-name="phrase button"
									data-tag-position={position}
									data-tag-value={phrase.replyText}
									type="button"
									variant="secondary"
									onClick={(evt: React.MouseEvent) => handleClick(evt, index)}
									className="hover:bg-cta-actionhover hover:text-white justify-center w-5/6 mx-1 mb-2 text-center break-words bg-white"
								>
									{phrase.displayText}
								</Button>
							);
						}
					)}
				</div>
			</div>
		);
	};

export default SuggestedPhrasesMessage;
